
import React from "react";

interface TimeFilterProps {
  activeFilter: "woche" | "monat" | "gesamt";
  onChange: (filter: "woche" | "monat" | "gesamt") => void;
}

export const TimeFilter = ({ activeFilter, onChange }: TimeFilterProps) => {
  const filters = [
    { value: "woche", label: "Woche" },
    { value: "monat", label: "Monat" },
    { value: "gesamt", label: "Gesamt" },
  ] as const;

  return (
    <div className="flex rounded-xl overflow-hidden border border-gray-700/30 shadow-sm bg-[#081426] h-9">
      {filters.map((filter) => (
        <button
          key={filter.value}
          className={`px-3 py-1.5 text-xs transition-all duration-200 ${
            activeFilter === filter.value
              ? "bg-gradient-to-r from-[#417F96] to-[#3a6f83] text-white shadow-inner"
              : "bg-transparent text-gray-400 hover:bg-gray-800/50 hover:text-gray-300"
          }`}
          onClick={() => onChange(filter.value)}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
};
